import angular from 'angular'

// components
import viewEditToggle from './component/viewEditToggle.js'

export default angular
  .module('portalApp.viewEditToggle', [])
  .component('viewEditToggle', viewEditToggle)
  .name
